import { render, staticRenderFns } from "./AddNewPost.vue?vue&type=template&id=4e6a4e7b&"
import script from "./AddNewPost.vue?vue&type=script&lang=js&"
export * from "./AddNewPost.vue?vue&type=script&lang=js&"
import style0 from "./AddNewPost.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports